module.exports = __webpack_public_path__ + "static/media/voltgroom-replacement-blade-4.81afc541.png";